<!--
 * @Author: 仙道
 * @Date: 2022-08-10 18:17:11
 * @LastEditTime: 2022-09-18 21:28:07
 * @email: hao.li08@weimob.com
 * @Description: 生产厂家详情
 * @FilePath: /iplus-iwt-fe/src/views/fusion/components/Person.vue
-->
<template>
  <page-layout :breadcrumb="false">
    <div class="page-header-content" slot="headerContent">
      <div class="content">
        <a-descriptions :column="4">
          <a-descriptions-item label="姓名">{{record.realname||'-'}}</a-descriptions-item>
          <a-descriptions-item label="联系方式">{{record.phone||'-'}}</a-descriptions-item>
          <a-descriptions-item label="角色">{{record.orgCodeTxt||'-'}}</a-descriptions-item>
          <a-descriptions-item label="岗位">{{record.telephone||'-'}}</a-descriptions-item>
        </a-descriptions>
      </div>
    </div>

    <div class="c-tabs">
      <a-card :bordered="false">
        <a-tabs v-if="!viewLoading">
          <a-tab-pane :key="item.key" :tab="item.tab" v-for="(item) in componentList">
            <component :is="item.views" :query="item.query" />
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </div>
  </page-layout>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import PageLayout from '@/components/page/PageLayout'
  import { getAction } from '@/api/manage'

  export default {
    // 人员详情
    name: 'FusionPerson',
    components: {
      PageLayout
    },
    props: {
      query: {
        type: Object,
        default: () => { }
      }

    },
    // 定义属性
    data () {
      return {
        mapKey: 'Manufacturers',
        record: {},
        componentList: [
          {
            view: 'DefRegisterListForDetail',
            path: 'equipment/defect/vue/DefRegisterListForDetail',
            name: '缺陷记录',
            queryAttr: 'defHandle'

          }, {
            view: 'IotAlertListForPerson',
            path: 'monitor/alert/IotAlertListForPerson',
            name: '告警记录',
            queryAttr: 'disposalPerson'
          },
          {
            view: 'YwDailyOverhaulTaskListForPerson',
            path: 'maintenance/overhaul/YwDailyOverhaulTaskListForPerson',
            name: '日常检修',
            queryAttr: 'manager'
          },
          {
            view: 'DevMaintainceTaskListForPerson',
            path: 'eMaintenance/DevMaintainceTaskListForPerson',
            name: '保养任务',
            queryAttr: 'responsibleId'
          }
          //eMaintenance/DevMaintainceTaskListForPerson
        ],
        viewLoading: true,
      }
    },


    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {

      this.Initialize()

      this.getInfoById()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      async getInfoById () {
        const { result, success } = await getAction('/sys/user/queryByIds', { userIds: this.$route.params?.id ?? this.query?.id })
        if (success) {
          this.record = { ...result[0] }
        }
      },
      Initialize () {
        const params = this.$route.params?.id ?? this.query?.id
        const tabs = this.componentList.reduce((arr, cur) => {
          arr.push({
            query: {
              [cur.queryAttr]: params
            },
            tab: cur.name,
            key: cur.view,
            views: (resolve) => require([`@/views/${cur.path}.vue`], resolve)
          })
          return arr
        }, [])

        this.componentList = tabs
        this.viewLoading = false

      }
    }
  }
</script>

<style lang='less' scoped>
  // @import './index.less';

  .detail-layout {
    margin-left: 44px;
  }
  .text {
    color: rgba(0, 0, 0, 0.45);
  }
  .c-tabs {
    background: #fff;
    &-panel {
      min-height: 400px;
      &-head {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .device-img {
    width: 100px !important;
    height: 100px !important;
    border-radius: 0% !important;
  }
  ::v-deep {
    .content {
      position: relative;
      margin-top: 0px;
    }
    .page-header {
      border-bottom: none;
    }
    .term {
      vertical-align: top;
    }
    .ant-descriptions-row {
      .ant-descriptions-item-label {
        vertical-align: inherit;
      }
      .ant-descriptions-item-content {
        vertical-align: inherit;
      }
    }
    .ant-upload.ant-upload-select-picture-card {
      height: 100px;
      width: 100px;
    }
    img {
      height: 40px;
      width: 40px;
    }
  }
</style>
